import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Wars} from "../../../interfaces/account-data";
import {Delivery} from "../../../interfaces/delivery";
import {LocalStorageService} from "../../../services/local-storage.service";

@Component({
  selector: 'app-delivery-list',
  templateUrl: './delivery-list.component.html',
  styleUrls: ['../../basket-confirm/basket-confirm.component.scss', './delivery-list.component.scss']
})
export class DeliveryListComponent implements OnInit {
  @Input() deliveryCurrent;
  @Input() deliveryList: Delivery[];
  @Input() wars: Wars[];
  @Output() deliveryChange = new EventEmitter<number>();

  delivery: number;

  constructor(public localStorage: LocalStorageService) {  }

  ngOnInit(): void {
    this.delivery = parseInt(this.localStorage.get('delivery_id'));
    this.sortDeliveryList();
  }

  sortDeliveryList() {
    this.deliveryList = Object.values(this.deliveryList).sort((a, b) => {
      const sortA = parseInt(a.sort);
      const sortB = parseInt(b.sort);

      if (sortA < sortB) {
        return -1;
      }
      if (sortA > sortB) {
        return 1;
      }

      return 0;
    });
  }

  setDelivery(id) {
    this.deliveryChange.emit(id);
  };
}
